const Booking = {
  computed: {
    // add insurance to complete price of booking returned by api
    completeTravelPrice() {
      let price = 0;
      if (this.priceData.priceObject) {
        price += this.priceData.priceObject.priceComplete;
      }

      if (this.priceInsurance) {
        price += this.priceInsurance;
      }
      return price;
    },

    // price on summary on object-page
    priceBeforeBooking() {
      let price = 0;
      if (this.priceData.priceObject) {
        price += this.priceData.priceObject.priceAtBooking;
        price += this.priceData.priceObject.priceAtBookingFees;
      }

      if (this.priceInsurance) {
        price += this.priceInsurance;
      }
      return price;
    },

    priceCostsTableBooking() {
      let price = this.priceBeforeBooking;

      if (this.priceData.bonus) {
        price -= this.priceData.bonus;
      }

      return price;
    },

    // which price has to be shown on widget on objectpage
    priceObject() {
      return this.completeTravelPrice;
    },

    priceAdditionals() {
      return this.priceAdditionalBeforeBooking;
    },

    // merge this price container
    priceAdditionalBeforeBooking() {
      // combine price before booking
      const data = {
        ...this.priceData.priceServices,
        ...this.priceData.priceServiceFees,
        ...this.priceData.priceServicesMandatory,
        ...this.priceData.priceServicesExtraChargesAtBooking,
      };
      return data;
    },

    // filter these empty additional costs to hide on first page
    priceAdditionalBeforeBookingWithCosts() {
      const dataWithValues = {};
      // only show additionals with prices
      Object.entries(this.priceAdditionalBeforeBooking).forEach(
        (serviceData) => {
          const [name, values] = serviceData;
          if (values.price > 0) {
            Object.assign(dataWithValues, { [name]: values });
          }
        },
      );
      return dataWithValues;
    },

    // filter these empty additional costs to hide on first page
    priceAdditionalAfterBookingWithCosts() {
      const dataWithValues = {};
      // only show additionals with prices
      Object.entries(this.priceData.priceServicesOnSiteMandatory).forEach(
        (serviceData) => {
          const [name, values] = serviceData;
          if (values.price > 0) {
            Object.assign(dataWithValues, { [name]: values });
          }
        },
      );
      return dataWithValues;
    },

    // original price
    originalPrice() {
      let price = 0;
      if (this.priceData.priceObject) {
        price += this.priceData.priceObject.original;
      }
      return price;
    },

    // get all mandantory costs
    mandatoryCosts() {
      return {
        ...this.priceData.priceServicesMandatory || {},
        ...this.priceData.priceServicesOnSiteMandatory || {},
        ...this.priceData.priceServicesExtraChargesAtBooking || {},
        ...this.priceData.priceServicesOnSiteOptional || {},
        ...this.priceData.priceServicesOnSiteMandantoryExclude || {},
      };
    },
  },
};

export default Booking;
